export default {
  markAllAsRead: 'Označiť všetky ako prečítané',
  showOnlyUnread: 'Zobraziť iba neprečítané',
  seeAll: 'Zobraziť všetko',
};
